/**
 * Shopify Configuration
 * 
 * This file contains all Shopify store configuration.
 * Update these values with your Shopify store details.
 */

// ============================================
// SHOPIFY STORE CONFIGURATION
// ============================================

// Your Shopify store domain (e.g., 'your-store.myshopify.com')
// Do NOT include 'https://' - just the domain
const SHOPIFY_STORE_DOMAIN = 'jrcogolf.myshopify.com';

// Storefront API Access Token (optional - only needed for Storefront API method)
// Get this from: Settings → Apps → Develop apps → [Your App] → Storefront API
// Format: 'shpat_xxxxxxxxxxxxx'
const SHOPIFY_STOREFRONT_TOKEN = '';

// Shopify API Version (default is fine for most cases)
const SHOPIFY_API_VERSION = '2024-01';

// ============================================
// PRODUCT VARIANT IDS
// ============================================
// 
// To find your variant IDs:
// 1. Go to Shopify Admin → Products
// 2. Click on a product
// 3. View the page source or check the URL for the product ID
// 4. For variants, you can use the browser's developer console on the product page
//    and run: document.querySelector('[data-variant-id]')?.dataset.variantId
// 5. Or use Shopify's GraphQL Admin API to query product variants
//
// For AJAX Cart API (iframe/embedded): Use numeric variant IDs (e.g., '12345678901234')
// For Storefront API: Use GID format (e.g., 'gid://shopify/ProductVariant/12345678901234')

const SHOPIFY_VARIANT_IDS = {
    // Replace these with your actual variant IDs
    'driver': 47359039045867,          // Driver Headcover variant ID
    'fairway': 47359039078635,         // Fairway Headcover variant ID
    'hybrid': 47359039111403,          // Hybrid Headcover variant ID
    'blade': 47359039144171,           // Blade Putter Headcover variant ID
    'mid-mallet': 47359039176939,      // Mid Mallet Headcover variant ID
    'mallet-standard': 47359039209707, // Standard Mallet Headcover variant ID
    'mallet-center': 47359039242475    // Center Shafted Mallet Headcover variant ID
};

// ============================================
// PRICE-TO-VARIANT MAPPING
// ============================================
// Map calculated prices to variant IDs
// Variants are priced in $5 increments starting at $125.99
// Format: price_in_cents: variant_id
// Example: 12599: 47359039045867 means $125.99 maps to variant ID 47359039045867
//
// To find variant IDs for each price:
// 1. Go to Shopify Admin → Products → Your Product
// 2. For each variant, note the price and variant ID
// 3. Add entries here: price_in_cents: variant_id
//
// Price format: Multiply dollar amount by 100 (e.g., $125.99 = 12599)
// IMPORTANT: Make sure each variant's price in Shopify matches its title!
// All variants currently show price: 12500 ($125.00) - they need to be updated to match their titles
const PRICE_TO_VARIANT_MAP = {
    12599: 47395671245035,  // $125.99
    13099: 47395671277803,  // $130.99
    13599: 47395671310571,  // $135.99
    14099: 47395671343339,  // $140.99
    14599: 47395671376107,  // $145.99
    15099: 47395671408875,  // $150.99
    15599: 47395671441643,  // $155.99
    16099: 47395671474411,  // $160.99
    16599: 47395671507179,  // $165.99
    17099: 47395671539947,  // $170.99
    17599: 47395671572715,  // $175.99
    18099: 47395671605483,  // $180.99
    18599: 47395671638251,  // $185.99
    19099: 47395671671019,  // $190.99
    19599: 47395671703787,  // $195.99
    20099: 47395671736555,  // $200.99
    20599: 47395671769323,  // $205.99
    21099: 47395672522987,  // $210.99
    21599: 47395672555755,  // $215.99
    22099: 47395687334123,  // $220.99
    22599: 47395672588523,  // $225.99
    23099: 47395672621291,  // $230.99
    23599: 47395672654059,  // $235.99
    24099: 47395672686827,  // $240.99 (Fixed: was using wrong ID)
    24599: 47395672719595,  // $245.99 (Fixed: was using wrong ID)
    25099: 47395672752363,  // $250.99
    25599: 47395672785131,  // $255.99
    26099: 47395672817899,  // $260.99
    26599: 47395672850667,  // $265.99
    27099: 47395672883435,  // $270.99
    27599: 47395672916203,  // $275.99
    28099: 47395672948971,  // $280.99
    28599: 47395672981739,  // $285.99
    29099: 47395673014507,  // $290.99
    29599: 47395673047275,  // $295.99
    30099: 47395673080043   // $300.99
};

// ============================================
// PRODUCT HANDLES (optional - for page-based routing)
// ============================================
// If you want to link to specific product pages after adding to cart

const SHOPIFY_PRODUCT_HANDLES = {
    'driver': 'driver-headcover',
    'fairway': 'fairway-headcover',
    'hybrid': 'hybrid-headcover',
    'blade': 'blade-putter-headcover',
    'mid-mallet': 'mid-mallet-headcover',
    'mallet-standard': 'standard-mallet-headcover',
    'mallet-center': 'center-shafted-mallet-headcover'
};

// ============================================
// INTEGRATION SETTINGS
// ============================================

// Redirect to cart after adding item? (true/false)
const REDIRECT_TO_CART = true;

// Show confirmation dialog before redirecting? (true/false)
const SHOW_CART_CONFIRMATION = true;

// Backend API URL (for saving order configurations)
// Leave empty if you don't want to save to backend
// Update this with your backend URL if you want to save orders
const BACKEND_API_URL = window.BACKEND_API_URL || 'https://jrcogolf.com/api' || '';

// ============================================
// IMAGE URLs (Shopify Files)
// ============================================
// If images are uploaded to Settings → Files, paste the URLs here
// Get URLs from: Settings → Files → Click on file → Copy URL

const IMAGE_URLS = {
    // Base product images
    'whitedriver.png': 'https://cdn.shopify.com/s/files/1/0758/6843/8763/files/whitedriver.png?v=1768938430',
    'fur.png': 'https://cdn.shopify.com/s/files/1/0758/6843/8763/files/fur.png?v=1768938429',
    'background.png': '', // Add your background.png URL here
    'Background.png': '', // Legacy reference - kept for compatibility
    'logo.png': 'https://cdn.shopify.com/s/files/1/0758/6843/8763/files/logo.png?v=1768938430',
    'whiteswatch.jpg': '', // Add your whiteswatch.jpg URL here
    
    // Material images - Add all your material image URLs here
    // Format: 'filename.jpg': 'your-url-here',
};

// Helper function to get image URL
function getImageUrl(filename) {
    // If URL is configured, use it
    if (IMAGE_URLS[filename] && IMAGE_URLS[filename] !== '') {
        return IMAGE_URLS[filename];
    }
    // Otherwise try relative path (for Assets)
    return filename;
}

// ============================================
// EXPORT CONFIGURATION
// ============================================

if (typeof window !== 'undefined') {
    window.SHOPIFY_CONFIG = {
        storeDomain: SHOPIFY_STORE_DOMAIN,
        storefrontToken: SHOPIFY_STOREFRONT_TOKEN,
        apiVersion: SHOPIFY_API_VERSION,
        variantIds: SHOPIFY_VARIANT_IDS,
        productHandles: SHOPIFY_PRODUCT_HANDLES,
        redirectToCart: REDIRECT_TO_CART,
        showCartConfirmation: SHOW_CART_CONFIRMATION,
        backendApiUrl: BACKEND_API_URL,
        imageUrls: IMAGE_URLS,
        getImageUrl: getImageUrl,
        priceToVariantMap: PRICE_TO_VARIANT_MAP
    };
    
    console.log('✅ Shopify configuration loaded');
}

